import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';

import { State, getIsUserLogged } from '../reducers';
import { AuthService } from './auth.service';


@Injectable()
export class AuthGuard  {

  isUserLogged = false;

  constructor(private store: Store<State>,
    private router: Router,
    private authService: AuthService) {
    this.store
      .select(getIsUserLogged)
      .subscribe((isUserLogged: boolean) => {
        this.isUserLogged = isUserLogged;
      });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkLogin(state.url);
  }

  checkLogin(url: string): boolean {
    if (this.isUserLoggedIn()) {
      return true;
    }

    this.authService.redirectUrl = url;
    this.router.navigate(['/login']);
    return false;
  }

  /** Store may lag behind localStorage for a tick; both mean an active session. */
  private isUserLoggedIn(): boolean {
    return this.isUserLogged || this.authService.hasUserInStorage();
  }
}
